module.exports = __webpack_public_path__ + "files/reaexplaur.f8ce4884e69e72c216aed9a89362e650.pdf";